import { PortfolioUtilities as portfolioUtilities } from "@common/portfolio.utilities";
import { PortfolioRepo as portfolioRepo } from "@services/portfolio.repo";
import { AuthService } from "@common/auth.service";
import * as _ from "lodash";
import * as moment from "moment";
import { Roles } from "@common/enums/Roles";
import { ClientRepo as clientRepo } from "@services/clients/client.repo";
import angular = require("angular");
import { ExternalSourceName } from "@common/enums/ExternalSources";
import { ClientDetails } from "@models/clients/clientDetailsModel";
import { IS_RECONCILED_FLAG } from "@constants/reporting";
import { extractErrorMessage } from "@common/utils/errorUtils";
class PortfolioManagementPerformanceController implements angular.IOnInit {
  public selectedPortfolioIds: Array<number>;
  public selectedCurrency: string;
  public clientPortfolios: any;

  // performanceParameters
  public performanceParameters: any;
  public monthlyPerformanceParameters: any;

  // filter options
  public fromDate;
  public toDate;
  public lastMonth;
  public isLoading: boolean = false;
  public combinedLoading: boolean = false;
  public dailyLoading: boolean = false;
  public combinedMonthlyLoading: boolean = false;

  public currentDate;
  public clientNumber: any;
  public client: ClientDetails;

  public combinedYearlyPerformance: any;
  public combinedYearlyPerformanceLocal: any;
  public combinedYearlyPerformanceInt: any;
  public combinedMonthlyPerformance: any;
  public combinedMonthlyPerformanceLocal: any;
  public combinedMonthlyPerformanceInt: any;

  public combinedPerformancesToDate: any;

  //public _portfolioHelper: PortfolioManagerSummaryHelper;
  public latestPortfolioValuationDate: string;
  public latestMCBEndOfMonthDate: string;
  private MCBExternalSourceName = ExternalSourceName.MCB;
  public displayReconciledDataFlag: boolean = false;
  public trailingTwelveMonthsPerformance: any;
  public financialYearToDate: any;

  /** @ngInject */
  constructor(
    private portfolioRepo: portfolioRepo,
    private $scope: angular.IScope,
    private portfolioUtilities: portfolioUtilities,
    private notifyjs,
    private $mdDialog: angular.material.IDialogService,
    private $rootScope: angular.IRootScopeService,
    private authService: AuthService,
    private $stateParams: angular.ui.IStateParamsService,
    private clientRepo: clientRepo
  ) {
    this.currentDate = new Date();
    this.lastMonth = new Date(
      moment(this.currentDate).subtract(1, "months").endOf("month").toString()
    );

    if (_.isEmpty(this.fromDate) || _.isEmpty(this.toDate)) {
      this.fromDate = new Date(
        moment(this.currentDate).subtract(12, "months").toString()
      ); //;
      this.toDate = this.currentDate;
    }
    //this._portfolioHelper = new PortfolioManagerSummaryHelper(clientRepo);
  }

  $onInit() {
    this.$scope["localPerformanceOptions"] = {
      data: [],
      urlSync: false,
    };
    this.$scope["localMonthlyPerformanceOptions"] = {
      data: [],
      urlSync: false,
    };
    this.$scope["internationalPerformanceOptions"] = {
      data: [],
      urlSync: false,
    };
    this.$scope["internationalMonthlyPerformanceOptions"] = {
      data: [],
      urlSync: false,
    };
    this.$scope["localYearlyPerformanceOptions"] = {
      data: [],
      urlSync: false,
    };
    this.$scope["internationalYearlyPerformanceOptions"] = {
      data: [],
      urlSync: false,
    };
    this.clientNumber = this.$stateParams["clientNumber"];
    this.displayReconciledDataFlag =
      sessionStorage.getItem(IS_RECONCILED_FLAG) === "true";
    this.getReconciledAndUnreconciledDates();
    this.getClientDetails(this.clientNumber);
    // selectedPortfolioIds is a component binding and may be undefined at init time.
    // Only attempt to load performance parameters if it's a valid, non-empty array.
    if (_.isArray(this.selectedPortfolioIds) && this.selectedPortfolioIds.length > 0) {
      this.getPerformanceParametersForSelectedPortfolio();
    }
  }

  // trigger updates to portfolio performance parameters based on the selected portfolioIds or currency
  // Note: We no longer auto-trigger search on changes - user must click Search button
  $onChanges(changes) {
    if (changes.selectedPortfolioIds || changes.selectedCurrency) {
      this.displayReconciledDataFlag =
        sessionStorage.getItem(IS_RECONCILED_FLAG) === "true";
      // Clear existing performance parameters when selection changes
      // User must click Search to load new data
      this.performanceParameters = new Array<any>();
    }
  }


  getClientDetails = (clientNumber) => {
    this.clientRepo.getClient(clientNumber, true).then((val) => {
      this.client = val.data as ClientDetails;
      this.getCombinedYearlyPerformance();
    });
  };

  getPerformanceParametersForSelectedPortfolio = () => {
    this.performanceParameters = new Array<any>();
    _.forEach(this.selectedPortfolioIds, (portfolioId) => {
      this.getPerformanceParameters(
        portfolioId,
        this.displayReconciledDataFlag && this.isMCBClientAccount(portfolioId)
      );
    });
  };

  getIndividualPortfolioPerformances(portfolio) {
    this.portfolioRepo
      .getPortfolioPerformance(
        this.selectedCurrency,
        [portfolio.portfolioId],
        null,
        null,
        this.displayReconciledDataFlag &&
          this.isMCBClientAccount(portfolio.portfolioId)
      )
      .then((val) => {
        portfolio.performancesToDate = val.data;
        portfolio.isLoading = false;
      })
      .catch((err) => {
        portfolio.isLoading = false;
      })
      .finally(() => (this.isLoading = false));
  }

  getCombinedPortfolioPerformances() {
    this.portfolioRepo
      .getPortfolioPerformance(
        this.selectedCurrency,
        this.selectedPortfolioIds,
        null,
        null,
        this.displayReconciledDataFlag
      )
      .then((val) => {
        this.combinedPerformancesToDate = val.data;
      })

      .finally(() => (this.isLoading = false));
  }

  public getPercentageFromDecimal(decimal: number) {
    return decimal * 100;
  }

  public getPercentageFromDecimalCombined(decimal: number) {
    return decimal * 100;
  }

  public formatPerformanceValue(decimal: number): string {
    if (decimal == null || decimal === undefined || isNaN(decimal)) {
      return '-';
    }
    return (decimal * 100).toFixed(2);
  }

  getCombinedYearlyPerformance = () => {
    if (this.client) {
      this.portfolioRepo
        .getCombinedYearly(
          this.client.id,
          this.selectedCurrency,
          this.selectedPortfolioIds,
          this.displayReconciledDataFlag
        )
        .then((res) => {
          let results = res.data as Array<any>;
          let combinedYearlyPerformance = _.filter(results, (item) => {
            return item.performanceType == 4;
          });
          this.combinedYearlyPerformance = _.filter(
            combinedYearlyPerformance,
            (item) => {
              return item.locality == 2;
            }
          );
          this.combinedYearlyPerformanceLocal = _.filter(
            combinedYearlyPerformance,
            (item) => {
              return item.locality == 0;
            }
          );
          this.combinedYearlyPerformanceInt = _.filter(
            combinedYearlyPerformance,
            (item) => {
              return item.locality == 1;
            }
          );
          let combinedMonthlyPerformance = _.filter(results, (item) => {
            return item.performanceType == 3;
          });
          this.combinedMonthlyPerformance = _.filter(
            combinedMonthlyPerformance,
            (item) => {
              return item.locality == 2;
            }
          );
          this.combinedMonthlyPerformanceLocal = _.filter(
            combinedMonthlyPerformance,
            (item) => {
              return item.locality == 0;
            }
          );
          this.combinedMonthlyPerformanceInt = _.filter(
            combinedMonthlyPerformance,
            (item) => {
              return item.locality == 1;
            }
          );
          this.combinedLoading = false;
          this.combinedMonthlyLoading = false;
          this.getTrailingTwelveMonthsPerformance()
          this.getFinancialYearToDatePerformance();
        })
        .then(() => {
          this.getCombinedPortfolioPerformances();
        });
    }
  };

  getPerformanceParameters = (portfolioId: number, isMCBAccount = true) => {
    this.isLoading = true;
    this.portfolioRepo
      .getPerformanceParameters(
        portfolioId,
        this.selectedCurrency,
        this.fromDate,
        this.toDate,
        this.displayReconciledDataFlag && isMCBAccount //Only MCB accounts have reconciled Data
      )
      .then((res) => {
        const data = res.data as Array<any>;
        let localPerformanceValue = 0;
        let localDailyPerformanceValue = 0;
        let internationalPerformanceValue = 0;
        let internationalDailyPerformanceValue = 0;

        let reportingCurrency = _.first(data).reportingCurrency;
        var localPerformance = _.filter(data, (item) => {
          return (
            item.locality == Locality.Local &&
            item.performanceType == PerformanceType.DAILY
          );
        });

        var localMonthlyPerformance = _.filter(data, (item) => {
          return (
            item.locality == Locality.Local &&
            item.performanceType == PerformanceType.MONTHLY
          );
        });

        var internationalPerformance = _.filter(data, (item) => {
          return (
            item.locality == Locality.International &&
            item.performanceType == PerformanceType.DAILY
          );
        });

        var internationalMonthlyPerformance = _.filter(data, (item) => {
          return (
            item.locality == Locality.International &&
            item.performanceType == PerformanceType.MONTHLY
          );
        });

        var localYearlyPerformance = _.filter(data, (item) => {
          return (
            item.locality == Locality.Local &&
            item.performanceType == PerformanceType.YEARLY
          );
        });

        var internationalYearlyPerformance = _.filter(data, (item) => {
          return (
            item.locality == Locality.International &&
            item.performanceType == PerformanceType.YEARLY
          );
        });
        let portfolioName,
          portfolioInception,
          portfolioInceptionDate = null;
        if (
          this.displayReconciledDataFlag &&
          this.isMCBClientAccount(portfolioId)
        ) {
          portfolioName =
            localMonthlyPerformance.length !== 0
              ? _.first(localMonthlyPerformance).portfolio.name
              : _.first(internationalMonthlyPerformance).portfolio.name;

          portfolioInception =
            localMonthlyPerformance.length !== 0
              ? _.first(localMonthlyPerformance).portfolio.inception
              : _.first(internationalMonthlyPerformance).portfolio.inception;

          portfolioInceptionDate =
            localMonthlyPerformance.length !== 0
              ? _.first(localMonthlyPerformance).portfolio.inceptionDate
              : _.first(internationalMonthlyPerformance).portfolio
                  .inceptionDate;
        } else {
          portfolioName =
            localPerformance.length !== 0
              ? _.first(localPerformance).portfolio.name
              : _.first(internationalPerformance).portfolio.name;

          portfolioInception =
            localPerformance.length !== 0
              ? _.first(localPerformance).portfolio.inception
              : _.first(internationalPerformance).portfolio.inception;

          portfolioInceptionDate =
            localPerformance.length !== 0
              ? _.first(localPerformance).portfolio.inceptionDate
              : _.first(internationalPerformance).portfolio.inceptionDate;
        }

        // Normalize inceptionDate to string format or null if invalid (for display)
        portfolioInceptionDate = this.normalizeInceptionDate(portfolioInceptionDate);

        //check if the portfolio performance parameter has been reloaded then just replace else add it to the performanceParameters list'
        if (!_.isEmpty(this.performanceParameters)) {
          // remove the object which has the same portfolio so that

          this.performanceParameters = _.reject(
            this.performanceParameters,
            (existingParameter) => {
              return existingParameter.portfolioName == portfolioName;
            }
          );

          this.performanceParameters.push({
            portfolioId: portfolioId,
            portfolioName: portfolioName,
            inception: portfolioInception,
            inceptionDate: portfolioInceptionDate,
            reportingCurrency: reportingCurrency,
            yearlyCalculationLoading: false,
            isLoading: true,
            isSaving: false,
            displayLocal: reportingCurrency === "MUR" ? true : false,
            localPerformanceValue: localPerformanceValue,
            localDailyPerformanceValue: localDailyPerformanceValue,
            internationalPerformanceValue: internationalPerformanceValue,
            internationalDailyPerformanceValue:
              internationalDailyPerformanceValue,
            performanceParameters: {
              localPerformance: localPerformance,
              internationalPerformance: internationalPerformance,
            },
            monthlyPerformanceParameters: {
              localPerformance: localMonthlyPerformance,
              internationalPerformance: internationalMonthlyPerformance,
            },
            yearlyPerformanceParameters: {
              localPerformance: localYearlyPerformance,
              internationalPerformance: internationalYearlyPerformance,
            },
          });
        } else {
          this.performanceParameters.push({
            portfolioId: portfolioId,
            portfolioName: portfolioName,
            inception: portfolioInception,
            inceptionDate: portfolioInceptionDate,
            reportingCurrency: reportingCurrency,
            yearlyCalculationLoading: false,
            isLoading: true,
            isSaving: false,
            displayLocal: reportingCurrency === "MUR" ? true : false,
            localPerformanceValue: localPerformanceValue,
            localDailyPerformanceValue: localDailyPerformanceValue,
            internationalPerformanceValue: internationalPerformanceValue,
            internationalDailyPerformanceValue:
              internationalDailyPerformanceValue,
            performanceParameters: {
              localPerformance: localPerformance,
              internationalPerformance: internationalPerformance,
            },
            monthlyPerformanceParameters: {
              localPerformance: localMonthlyPerformance,
              internationalPerformance: internationalMonthlyPerformance,
            },
            yearlyPerformanceParameters: {
              localPerformance: localYearlyPerformance,
              internationalPerformance: internationalYearlyPerformance,
            },
          });
        }
        this.performanceParameters = _.orderBy(
          this.performanceParameters,
          (performanceParameter) => {
            return performanceParameter.portfolioName;
          }
        );
      })
      .then(() => {
        _.forEach(this.performanceParameters, (portfolio) => {
          this.getIndividualPortfolioPerformances(portfolio);
        });
      })
      .catch((err) => {
        // Clear loading state for the portfolio that failed
        const failedPortfolio = _.find(this.performanceParameters, (p) => p.portfolioId === portfolioId);
        if (failedPortfolio) {
          failedPortfolio.isLoading = false;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  };

  formatPerformancePercentage(performance) {
    return (performance * 100).toFixed(2);
  }

  displayCashTransactions(performanceParameter, portfolio) {
    performanceParameter.showCashTransactions =
      !performanceParameter.showCashTransactions;

    if (_.isEmpty(performanceParameter.cashTransactions)) {
      this.isLoading = true;
      let locality =
        portfolio.displayLocal === true
          ? Locality.Local
          : Locality.International;
      let fromDate = performanceParameter.performanceDate;
      let toDate = performanceParameter.performanceDate;
      if (performanceParameter.performanceType == PerformanceType.MONTHLY) {
        fromDate = moment(performanceParameter.performanceDate)
          .startOf("month")
          .format("YYYY-MM-DD");
        toDate = performanceParameter.performanceDate;
      }

      this.portfolioRepo
        .getCashTransactionsForPortfolio(
          performanceParameter.portfolio.portfolioId,
          fromDate,
          toDate,
          locality,
          this.displayReconciledDataFlag &&
            this.isMCBClientAccount(performanceParameter.portfolio.portfolioId)
        )
        .then((res) => {
          this.isLoading = false;
          performanceParameter.cashTransactions = res.data;
          performanceParameter.cashTransactions = _.filter(
            performanceParameter.cashTransactions,
            (transaction) => {
              return transaction.cashAccount.locality === locality;
            }
          );
        })
        .catch((err) => {
          this.isLoading = false;
        });
    }
  }

  formatBooleanValue(val: boolean) {
    return val ? "Yes" : "No";
  }

  editCashTransaction(cashTransaction, performanceParameter) {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.cashTransaction = cashTransaction;
    tempScope.isReconciled = this.displayReconciledDataFlag && this.isMCBClientAccount(performanceParameter.portfolio.portfolioId);
    this.$mdDialog
      .show({
        template: `<cash-transaction-dialog cash-transaction="cashTransaction" is-reconciled="isReconciled"></cash-transaction-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        if (result) {
          this.getPerformanceParameters(
            performanceParameter.portfolio.portfolioId,
            this.isMCBClientAccount(performanceParameter.portfolio.portfolioId)
          );
        }
      });
  }

  recalculatePerformanceMonthly = (portfolio) => {
    this.portfolioRepo
      .recalculatePerformanceMonthly(
        portfolio.portfolioId,
        this.fromDate,
        this.toDate,
        false,
        this.displayReconciledDataFlag &&
          this.isMCBClientAccount(portfolio.portfolioId)
      )
      .then((res) => {
        this.getPerformanceParameters(
          portfolio.portfolioId,
          this.isMCBClientAccount(portfolio.portfolioId)
        );
      })
      .catch((err) => {});
  };

  recalculatePerformanceDaily = (portfolio) => {
    this.dailyLoading = true;
    this.portfolioRepo
      .recalculatePerformanceDaily(
        portfolio.portfolioId,
        this.toDate,
        false,
        this.displayReconciledDataFlag &&
          this.isMCBClientAccount(portfolio.portfolioId)
      )
      .then((res) => {
        this.dailyLoading = false;
        this.getPerformanceParameters(
          portfolio.portfolioId,
          this.isMCBClientAccount(portfolio.portfolioId)
        );
      })
      .catch((err) => {this.dailyLoading = false;});
  };
  

  recalculateYearlyPerformance = (portfolio) => {
    let fromDate = moment("2018-01-01").startOf("year").format("YYYY-MM-DD");
    let toDate = moment().endOf("year").format("YYYY-MM-DD");
    this.performanceParameters.filter(
      (performance) => performance.portfolioId === portfolio.portfolioId
    )[0].yearlyCalculationLoading = true;
    this.portfolioRepo
      .recalculateYearlyPerformance(
        portfolio.portfolioId,
        fromDate,
        toDate,
        false,
        this.displayReconciledDataFlag &&
          this.isMCBClientAccount(portfolio.portfolioId)
      )
      .then((res) => {
        this.getPerformanceParameters(
          portfolio.portfolioId,
          this.isMCBClientAccount(portfolio.portfolioId)
        );
      })
      .catch((err) => {});
  };

  recalculateSpecificYearPerformance = (portfolio) => {
    let fromDate = moment(portfolio.performanceDate)
      .startOf("year")
      .format("YYYY-MM-DD");
    let toDate = moment(portfolio.performanceDate)
      .endOf("year")
      .format("YYYY-MM-DD");

    portfolio.isLoadingRecalculation = true;
    this.portfolioRepo
      .recalculateYearlyPerformance(
        portfolio.portfolio.portfolioId,
        fromDate,
        toDate,
        false,
        this.displayReconciledDataFlag &&
          this.isMCBClientAccount(portfolio.portfolio.portfolioId)
      )
      .then((res) => {
        this.getPerformanceParameters(
          portfolio.portfolio.portfolioId,
          this.isMCBClientAccount(portfolio.portfolio.portfolioId)
        );
        // portfolio.isLoadingRecalculation = false;
      })
      .catch((err) => {})
      .finally(() => {
        // portfolio.isLoadingRecalculation = false;
      });
  };

  addCashTransaction = (portfolio) => {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.portfolio = portfolio;
    const isReconciled = this.displayReconciledDataFlag;
    tempScope.isReconciled = isReconciled;

    this.$mdDialog
      .show({
        template: `<md-dialog flex="40"><create-cash-transaction-dialog portfolio="portfolio" is-reconciled="isReconciled" ></create-cash-transaction-dialog></md-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        if (result) {
          this.getPerformanceParameters(
            portfolio.portfolioId,
            this.isMCBClientAccount(portfolio.portfolio.portfolioId)
          );
        }
      });
  };

  disableRecalculatePerformance = (performanceParameter) => {
    if (performanceParameter.isLocked) {
      return !this.isSeniorManager();
    }
    return false;
  };

  isSeniorManager = (): boolean => {
    return (
      this.authService.getUserRoles().indexOf(Roles.SeniorManagement) > -1 ||
      this.authService.getUserRoles().indexOf(Roles.SystemAdministrator) > -1
    );
  };

  recalculateMonthlyPerformance = (
    performanceParameter,
    $event: angular.IAngularEvent
  ) => {
    $event.stopPropagation();

    let fromDate = moment(performanceParameter.performanceDate)
      .startOf("month")
      .format("YYYY-MM-DD");
    let toDate = moment(performanceParameter.performanceDate)
      .endOf("month")
      .format("YYYY-MM-DD");

    let forceCalculate = false;

    let that = this;

    if (performanceParameter.isOverridden) {
      var confirm = this.$mdDialog
        .confirm()
        .title("Are you sure you want to recalculate ? ")
        .textContent(
          "The performance for this month has already been previously overridden. If you continue the system will recalculate the performance."
        )
        .ariaLabel("RecalculatePerformanceMonthly")
        .targetEvent()
        .ok("Continue")
        .cancel("Cancel");

      this.$mdDialog.show(confirm).then(
        
        function () {
          forceCalculate = true;
          performanceParameter.isLoadingRecalculation = true;

          let isReconciled = (that.displayReconciledDataFlag !== null && 
            that.displayReconciledDataFlag !== undefined && 
            that.displayReconciledDataFlag) && 
           that.isMCBClientAccount(performanceParameter.portfolio.portfolioId);

          that.portfolioRepo
            .recalculatePerformanceMonthly(
              performanceParameter.portfolio.portfolioId,
              fromDate,
              toDate,
              forceCalculate,
              isReconciled
            )
            .then((res) => {
              that.isLoading = false;
              that.getPerformanceParameters(
                performanceParameter.portfolio.portfolioId,
                that.isMCBClientAccount(
                  performanceParameter.portfolio.portfolioId
                )
              );
            })
            .catch((err) => {
              that.isLoading = false;
            })
            .finally(
              () => (performanceParameter.isLoadingRecalculation = false)
            );
        },
        function () {}
      );
    } else {
      performanceParameter.isLoadingRecalculation = true;
      this.portfolioRepo
        .recalculatePerformanceMonthly(
          performanceParameter.portfolio.portfolioId,
          fromDate,
          toDate,
          forceCalculate,
          this.displayReconciledDataFlag &&
            this.isMCBClientAccount(performanceParameter.portfolio.portfolioId)
        )
        .then((res) => {
          this.getPerformanceParameters(
            performanceParameter.portfolio.portfolioId,
            this.isMCBClientAccount(
              performanceParameter.portfolio.portfolio.portfolioId
            )
          );
        })
        .catch((err) => {})
        .finally(() => (performanceParameter.isLoadingRecalculation = false));
    }
  };

  editPerformance = (performanceParameter, $event: angular.IAngularEvent) => {
    $event.stopPropagation();
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.performanceParameter = performanceParameter;
    tempScope.portfolioId = performanceParameter.portfolio.portfolioId;
    tempScope.locality = performanceParameter.locality;
    tempScope.performanceDate = performanceParameter.performanceDate;

    this.$mdDialog
      .show({
        template: `<performance-parameter-dialog portfolio-id="portfolioId" locality="locality" performance-date="performanceDate"></performance-parameter-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        if (result) {
          this.getPerformanceParameters(
            performanceParameter.portfolio.portfolioId,
            this.isMCBClientAccount(performanceParameter.portfolio.portfolioId)
          );
        }
      });
  };

  getTitle = (performanceParameter) => {
    let title = "";
    if (performanceParameter.isOverridden) {
      title += `\n Overridden by - ${
        performanceParameter.overriddenBy.name
      } on ${new Date(performanceParameter.overriddenOn)
        .toISOString()
        .substr(0, 10)} at ${new Date(
        performanceParameter.overriddenOn
      ).toLocaleTimeString()}
      \n Comment : ${performanceParameter.comment}`;
    }
    if (performanceParameter.hasAdhocOverriddenCashTransactions) {
      title += `\n There are Ad-hoc or Overridden Cash Transactions in this month.`;
    }
    if (performanceParameter.isLocked) {
      title += `\n The performance values for this month have been locked.
                \n Locked By - ${performanceParameter.lockedBy}
                \n Locked On - ${new Date(performanceParameter.lockedOn)
                  .toISOString()
                  .substr(0, 10)}
                `;
    }

    return title;
  };

  getYearTitle = (performanceParameter) => {
    let title = "";
    if (performanceParameter.isOverridden) {
      title += `\n Overridden by - ${
        performanceParameter.overriddenBy.name
      } on ${new Date(performanceParameter.overriddenOn)
        .toISOString()
        .substr(0, 10)} at ${new Date(
        performanceParameter.overriddenOn
      ).toLocaleTimeString()}
      \n Comment : ${performanceParameter.comment}`;
    }
    if (performanceParameter.hasAdhocOverriddenCashTransactions) {
      title += `\n There are Ad-hoc or Overridden Cash Transactions in this year.`;
    }
    if (performanceParameter.isLocked) {
      title += `\n The performance values for this year have been locked.
                \n Locked By - ${performanceParameter.lockedBy}
                \n Locked On - ${new Date(performanceParameter.lockedOn)
                  .toISOString()
                  .substr(0, 10)}
                `;
    }

    return title;
  };

  getRowBackGroundColour = (performanceParameter) => {
    if (!_.isUndefined(performanceParameter)) {
      if (
        performanceParameter.isOverridden &&
        performanceParameter.hasAdhocOverriddenCashTransactions
      ) {
        return `{ 'red-text': true, 'cash-transaction-overridden-highlight': true }`;
      } else if (
        performanceParameter.isOverridden &&
        !performanceParameter.hasAdhocOverriddenCashTransactions
      ) {
        return `{ 'red-text': true }`;
      } else if (
        performanceParameter.hasAdhocOverriddenCashTransactions &&
        performanceParameter.isOverridden
      ) {
        return `{ 'cash-transaction-overridden-highlight': true }`;
      }
    }
  };

  togglePerformanceLock = (performanceParameter) => {
    if (performanceParameter.isRequesterAndBalanceEditorTheSame) {
      performanceParameter.isLocked = !performanceParameter.isLocked;
      this.notifyjs("Not authorised to lock performance.");
      return;
    }
    this.isLoading = true;
    this.portfolioRepo
      .togglePerformanceLock(
        performanceParameter.portfolio.portfolioId,
        performanceParameter.performanceDate,
        performanceParameter.isLocked,
        "Monthly",
        this.displayReconciledDataFlag &&
          this.isMCBClientAccount(performanceParameter.portfolio.portfolioId)
      )
      .then((res) => {
        this.getPerformanceParameters(
          performanceParameter.portfolio.portfolioId,
          this.isMCBClientAccount(performanceParameter.portfolio.portfolioId)
        );
      })
      .catch((err) => {
        this.notifyjs("Could not lock performance " + extractErrorMessage(err));
      })
      .finally(() => (this.isLoading = false));
  };

  togglePerformanceLockYearly = (performanceParameter) => {
    this.isLoading = true;
    this.portfolioRepo
      .togglePerformanceLock(
        performanceParameter.portfolio.portfolioId,
        performanceParameter.performanceDate,
        performanceParameter.isLocked,
        "Yearly",
        this.displayReconciledDataFlag &&
          this.isMCBClientAccount(performanceParameter.portfolio.portfolioId)
      )
      .then((res) => {
        this.getPerformanceParameters(
          performanceParameter.portfolio.portfolioId,
          this.isMCBClientAccount(performanceParameter.portfolio.portfolioId)
        );
      })
      .catch((err) => {
        this.notifyjs("Could not lock performance " + extractErrorMessage(err));
      })
      .finally(() => (this.isLoading = false));
  };

  toggleCombinedPerformanceLockYearly = (performanceParameter) => {
    this.portfolioRepo
      .toggleCombinedPerformanceLock(
        performanceParameter.id,
        performanceParameter.isLocked,
        this.displayReconciledDataFlag
      )
      .then((res) => {
        this.getCombinedYearlyPerformance();
      })
      .catch((err) => {
        this.notifyjs("Could not lock performance " + extractErrorMessage(err));
      })
      .finally(() => (this.isLoading = false));
  };

  toggleCombinedPerformanceLockMonthly = (performanceParameter) => {
    this.portfolioRepo
      .toggleCombinedPerformanceLock(
        performanceParameter.id,
        performanceParameter.isLocked,
        this.displayReconciledDataFlag
      )
      .then((res) => {
        this.getCombinedYearlyPerformance();
      })
      .catch((err) => {
        this.notifyjs("Could not lock performance " + extractErrorMessage(err));
      })
      .finally(() => (this.isLoading = false));
  };

  deleteCashAdhocTransaction = (cashTransaction, performanceParameter) => {
    if (cashTransaction.isAdhoc) {
      this.isLoading = true;
      this.portfolioRepo
        .deleteCashTransaction(
          cashTransaction.id,
          this.displayReconciledDataFlag &&
            this.isMCBClientAccount(performanceParameter.portfolio.portfolioId)
        )
        .then((res) => {
          this.getPerformanceParameters(
            performanceParameter.portfolio.portfolioId,
            this.isMCBClientAccount(performanceParameter.portfolio.portfolioId)
          );
        })
        .catch()
        .finally(() => (this.isLoading = false));
    }
  };

  handleSearch = () => {
    // Trigger search for performance parameters
    this.getPerformanceParametersForSelectedPortfolio();
    this.getCombinedYearlyPerformance();
  };

  handleAll = () => {
    // Set max date range and trigger search
    this.fromDate = moment("2018-01-31").format("YYYY-MM-DD");
    this.toDate = moment(this.currentDate)
      .subtract(1, "months")
      .endOf("month")
      .format("YYYY-MM-DD");
    this.handleSearch();
  };

  formatDate(selectedDate) {
    return moment(selectedDate).endOf("month").format("YYYY-MM");
  }

  normalizeInceptionDate(date: any): string | null {
    // If date is null, undefined, or empty, return null
    if (!date || date === null || date === undefined || date === '') {
      return null;
    }

    // Convert to moment object if it's a string or Date
    const dateMoment = moment(date);
    
    // Check if it's the default invalid date (0001-01-01 or 0001-01-01T00:00:00) or invalid
    if (!dateMoment.isValid() || dateMoment.year() === 1) {
      return null;
    }

    // Return as string in YYYY-MM-DD format
    return dateMoment.format('YYYY-MM-DD');
  }

  savePerformanceInception(portfolio) {
    // Validate that inception date is set
    if (!portfolio.inceptionDate || portfolio.inceptionDate === null || portfolio.inceptionDate === '') {
      this.notifyjs('Please select an Inception Date before saving.');
      return;
    }

    // Normalize the date (convert to YYYY-MM-DD format if valid)
    const normalizedDate = this.normalizeInceptionDate(portfolio.inceptionDate);
    
    // Double-check after normalization (in case it was an invalid date string)
    if (!normalizedDate) {
      this.notifyjs('Please select a valid Inception Date before saving.');
      return;
    }

    // Update portfolio with normalized date
    portfolio.inceptionDate = normalizedDate;
    
    // Set saving state
    portfolio.isSaving = true;
    
    this.portfolioRepo
      .updatePortfolioInception(
        portfolio,
        this.displayReconciledDataFlag &&
          this.isMCBClientAccount(portfolio.portfolioId)
      )
      .then((results) => {
        this.notifyjs('Portfolio inception saved successfully.', 'success');
        this.getPerformanceParametersForSelectedPortfolio();
      })
      .catch((err) => {
        this.notifyjs(extractErrorMessage(err, 'Error saving portfolio inception.'));
      })
      .finally(() => {
        portfolio.isSaving = false;
      });
  }

  addYearlyTransaction(portfolio) {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.portfolio = portfolio;
    tempScope.type = "single";
    tempScope.month = false;
    tempScope.allPortfolios = this.selectedPortfolioIds;
    tempScope.edit = false;
    this.$mdDialog
      .show({
        template: `<md-dialog flex="50"><yearly-transaction-dialog portfolio="portfolio" type="type" month="month" edit="edit"></yearly-transaction-dialog></md-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        this.getPerformanceParameters(
          portfolio.portfolioId,
          this.isMCBClientAccount(portfolio.portfolioId)
        );
      });
  }

  editYearlyPerformance(performance, portfolio) {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.portfolio = portfolio;
    tempScope.transaction = performance;
    tempScope.type = "single";
    tempScope.month = false;
    tempScope.edit = true;
    this.$mdDialog
      .show({
        template: `<md-dialog flex="70"><yearly-transaction-dialog portfolio="portfolio" transaction="transaction" type="type" month="month" edit="edit"></yearly-transaction-dialog></md-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        this.getPerformanceParameters(
          portfolio.portfolioId,
          this.isMCBClientAccount(portfolio.portfolioId)
        );
      });
  }

  addCombinedYearlyTransaction() {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.type = "combined";
    tempScope.client = this.client;
    tempScope.month = false;
    tempScope.allPortfolios = this.selectedPortfolioIds;
    tempScope.edit = false;
    this.$mdDialog
      .show({
        template: `<md-dialog flex="50"><yearly-transaction-dialog type="type" client="client" month="month" all-portfolios="allPortfolios" edit="edit"></yearly-transaction-dialog></md-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        this.getCombinedYearlyPerformance();
      });
  }

  editCombinedYearlyPerformance(performance) {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.transaction = performance;
    tempScope.type = "combined";
    tempScope.client = this.client;
    tempScope.month = false;
    tempScope.allPortfolios = this.selectedPortfolioIds;
    tempScope.edit = true;
    this.$mdDialog
      .show({
        template: `<md-dialog flex="70"><yearly-transaction-dialog transaction="transaction" type="type" client="client" month="month" all-portfolios="allPortfolios" edit="edit"></yearly-transaction-dialog></md-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        this.getCombinedYearlyPerformance();
      });
  }

  editCombinedMonthlyPerformance(performance) {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.transaction = performance;
    tempScope.type = "combined";
    tempScope.client = this.client;
    tempScope.month = true;
    tempScope.allPortfolios = this.selectedPortfolioIds;
    tempScope.edit = true;
    this.$mdDialog
      .show({
        template: `<md-dialog flex="70"><yearly-transaction-dialog transaction="transaction" type="type" client="client" month="month"  all-portfolios="allPortfolios" edit="edit"></yearly-transaction-dialog></md-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        this.getCombinedYearlyPerformance();
      });
  }

  recalculateCombinedPerformance() {
    this.combinedLoading = true;
    let fromDate = moment("2018-01-01").startOf("year").format("YYYY-MM-DD");
    let toDate = moment().endOf("year").format("YYYY-MM-DD");
    let portfolios = this.performanceParameters.map((element) => {
      return {
        portfolioId: element.portfolioId,
        locality: element.displayLocal === true ? 0 : 1,
      };
    });
    this.portfolioRepo
      .recalculateCombinedYearlyPerformance(
        this.client.id,
        fromDate,
        toDate,
        this.selectedPortfolioIds,
        this.displayReconciledDataFlag
      )
      .then((res) => {
        this.getCombinedYearlyPerformance();
      })
      .catch((err) => {});
  }

  recalculateLatestCombinedPerformance() {
    this.combinedLoading = true;

    let fromDate = moment(this.combinedYearlyPerformance[0].performanceDate)
      .add(1, "days")
      .startOf("year")
      .format("YYYY-MM-DD");
    let toDate = moment().endOf("year").format("YYYY-MM-DD");
    let portfolios = this.performanceParameters.map((element) => {
      return {
        portfolioId: element.portfolioId,
        locality: element.displayLocal === true ? 0 : 1,
      };
    });
    this.portfolioRepo
      .recalculateCombinedYearlyPerformance(
        this.client.id,
        fromDate,
        toDate,
        this.selectedPortfolioIds,
        this.displayReconciledDataFlag
      )
      .then((res) => {
        this.getCombinedYearlyPerformance();
      })
      .catch((err) => {});
  }

  recalculateCombinedMonthlyPerformance() {
    this.combinedMonthlyLoading = true;
    let fromDate = moment("2018-01-01").startOf("year").format("YYYY-MM-DD");
    let toDate = moment().endOf("year").format("YYYY-MM-DD");
    let portfolios = this.performanceParameters.map((element) => {
      return {
        portfolioId: element.portfolioId,
        locality: element.displayLocal === true ? 0 : 1,
      };
    });
    this.portfolioRepo
      .recalculateCombinedMonthlyPerformance(
        this.client.id,
        fromDate,
        toDate,
        this.selectedPortfolioIds,
        this.displayReconciledDataFlag
      )
      .then((res) => {
        this.getCombinedYearlyPerformance();
      })
      .catch((err) => {});
  }
  recalculateLatestCombinedMonthlyPerformance() {
    this.combinedMonthlyLoading = true;
    let fromDate = moment(this.combinedMonthlyPerformance[0].performanceDate)
      .add(1, "days")
      .format("YYYY-MM-DD");
    let toDate = moment().endOf("year").format("YYYY-MM-DD");
    let portfolios = this.performanceParameters.map((element) => {
      return {
        portfolioId: element.portfolioId,
        locality: element.displayLocal === true ? 0 : 1,
      };
    });
    this.portfolioRepo
      .recalculateCombinedMonthlyPerformance(
        this.client.id,
        fromDate,
        toDate,
        this.selectedPortfolioIds,
        this.displayReconciledDataFlag
      )
      .then((res) => {
        this.getCombinedYearlyPerformance();
      })
      .catch((err) => {});
  }

  recalculateCombinedSpecificYearPerformance(year) {
    let fromDate = moment(year.performanceDate).format("YYYY-MM-DD");
    let toDate = moment(year.performanceDate).format("YYYY-MM-DD");
    let portfolios = this.performanceParameters.map((element) => {
      return {
        portfolioId: element.portfolioId,
        locality: element.displayLocal === true ? 0 : 1,
      };
    });
    year.isLoadingRecalculation = true;
    this.portfolioRepo
      .recalculateCombinedYearlyPerformance(
        this.client.id,
        fromDate,
        toDate,
        this.selectedPortfolioIds,
        this.displayReconciledDataFlag
      )
      .then((res) => {
        this.getCombinedYearlyPerformance();
        // portfolio.isLoadingRecalculation = false;
      })
      .catch((err) => {})
      .finally(() => {
        // portfolio.isLoadingRecalculation = false;
      });
  }

  recalculateCombinedSpecificMonthlyPerformance(month) {
    let fromDate = moment(month.performanceDate)
      .startOf("month")
      .format("YYYY-MM-DD");
    let toDate = moment(month.performanceDate)
      .endOf("month")
      .format("YYYY-MM-DD");
    let portfolios = this.performanceParameters.map((element) => {
      return {
        portfolioId: element.portfolioId,
        locality: element.displayLocal === true ? 0 : 1,
      };
    });
    month.isLoadingRecalculation = true;
    this.portfolioRepo
      .recalculateCombinedMonthlyPerformance(
        this.client.id,
        fromDate,
        toDate,
        this.selectedPortfolioIds,
        this.displayReconciledDataFlag
      )
      .then((res) => {
        this.getCombinedYearlyPerformance();
        // portfolio.isLoadingRecalculation = false;
      })
      .catch((err) => {})
      .finally(() => {
        // portfolio.isLoadingRecalculation = false;
      });
  }

  getReconciledAndUnreconciledDates() {
    this.clientRepo
      .getLatestPVDates()
      .then((res) => {
        let dataFeedData: any = res.data;

        let reconciledDateObject = _.first(
          _.filter(dataFeedData, (dataFeed) => {
            return (
              dataFeed.dataFeedSourceName === this.MCBExternalSourceName &&
              dataFeed.isReconciled
            );
          })
        );

        if (reconciledDateObject !== null) {
          let reconciledDate = moment(reconciledDateObject.fileDate).format(
            "DD-MM-YYYY"
          );
          let latestMCBPortfolioValuationDate = moment(
            reconciledDateObject.dateCompleted
          ).format("DD-MM-YYYY");
          this.latestMCBEndOfMonthDate = `Data last received: ${reconciledDate} on ${latestMCBPortfolioValuationDate}`;
        }

        let fileDates = dataFeedData
          .filter((feed) => {
            return !feed.isReconciled;
          })
          .map((feed) => {
            return moment(new Date(feed.fileDate));
          });

        let unreconciledDate = moment.min(fileDates).format("DD-MM-YYYY");

        this.latestPortfolioValuationDate = `Data last received on: ${unreconciledDate}`;
      })
      .then(() => {});
  }

  displayReconciledData(flag: boolean) {
    this.displayReconciledDataFlag = flag;
    sessionStorage.setItem(
      IS_RECONCILED_FLAG,
      this.displayReconciledDataFlag.toString()
    );
    this.isLoading = true;
    this.getPerformanceParametersForSelectedPortfolio();
    this.getCombinedYearlyPerformance();
  }

  isMCBClientAccount(portfolioId: number) {
    const portfolio = this.client.portfolios.find(
      (p) => p.portfolioId === portfolioId
    );
    return portfolio.accounts.some((acc) => acc.accountSourceName === "MCB");
  }

  public getTrailingTwelveMonthsPerformance() {
    this.portfolioRepo
      .getTrailingTwelveMonthsPerformance(
        this.selectedCurrency,
        this.selectedPortfolioIds,
        this.getLatestMonthlyCombinedParameterDate(),
        this.displayReconciledDataFlag
      )
      .then((val) => {
        this.trailingTwelveMonthsPerformance = val.data;
      })
      .catch((err) => {});
  }

  public getFinancialYearToDatePerformance() {
    this.portfolioRepo
      .getFinancialYearToDatePerformance(
        this.selectedCurrency,
        this.selectedPortfolioIds,
        this.client.finYearStart,
        this.getLatestMonthlyCombinedParameterDate(),
        this.displayReconciledDataFlag
      )
      .then((val) => {
        this.financialYearToDate = val.data;
      })
      .catch((err) => {});
  }

  public getLatestMonthlyCombinedParameterDate() {
    if (!this.combinedMonthlyPerformanceLocal || this.combinedMonthlyPerformanceLocal.length === 0) {
      return null;
    }
    return this.combinedMonthlyPerformanceLocal[0].performanceDate;
  }
}

enum Locality {
  Local = 0,
  International,
  Combined,
}

enum PerformanceType {
  DAILY = 0,
  QUARTERLY,
  YEAR_TO_DATE,
  MONTHLY,
  YEARLY,
}

export const portfolioManagementPerformance: angular.IComponentOptions = {
  template: require("./portfolioadmin.performance.html"),
  controller: PortfolioManagementPerformanceController,
  bindings: {
    clientId: "<",
    selectedPortfolioIds: "<",
    selectedCurrency: "<",
    clientPortfolios: "<",
    client: "<",
  },
};

class PerformanceData {
  public id: any;
  public performanceDate: any;
  public currency: any;
  public client: any;
  public openingBalance: any;
  public closingBalance: any;
  public totalDebitAmount: any;
  public totalCreditAmount: any;
  public performance: any;
  public performanceType: any;
  public isLocked: any;
  public lockedBy: any;
  public lockedOn: any;
  public monthsInYear: any;
  public portfolios: any;
  public locality: any;
  public manualInput: any;
  public benchmarkPerformance: number;
  public combinedPerformance: any;
  constructor({
    id,
    performanceDate,
    currency,
    client,
    openingBalance,
    closingBalance,
    totalDebitAmount,
    totalCreditAmount,
    performance,
    performanceType,
    isLocked,
    lockedBy,
    lockedOn,
    monthsInYear,
    portfolios,
    locality,
    manualInput,
    benchmarkPerformance = 0,
    combinedPerformance,
  }) {
    this.id = id;
    this.performanceDate = new Date(performanceDate);
    this.currency = currency;
    this.client = client;
    this.openingBalance = openingBalance;
    this.closingBalance = closingBalance;
    this.totalDebitAmount = totalDebitAmount;
    this.totalCreditAmount = totalCreditAmount;
    this.performance = performance;
    this.performanceType = performanceType;
    this.isLocked = isLocked;
    this.lockedBy = lockedBy;
    this.lockedOn = lockedOn ? new Date(lockedOn) : null;
    this.monthsInYear = monthsInYear;
    this.portfolios = portfolios.split(", ");
    this.locality = locality;
    this.manualInput = manualInput;
    this.benchmarkPerformance =
      benchmarkPerformance === null || benchmarkPerformance === undefined
        ? 0.0
        : benchmarkPerformance;
    this.combinedPerformance = combinedPerformance;
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/performanceManagement/portfolioadmin.performance.ts